import { render, staticRenderFns } from "./ColorPickerFullScreen.vue?vue&type=template&id=2f90cce4&scoped=true"
import script from "./ColorPickerFullScreen.vue?vue&type=script&lang=js"
export * from "./ColorPickerFullScreen.vue?vue&type=script&lang=js"
import style0 from "./ColorPickerFullScreen.vue?vue&type=style&index=0&id=2f90cce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f90cce4",
  null
  
)

export default component.exports